<template>
    <van-dialog v-model="isVisibility" :show-confirm-button="false">
        <!-- 在微信中打开H5 -->
        <div :class="{'diyModal': true, 'wechat': isWechat}">
            <div class="arrow-wrap"><img class="arrow" src="static/image/guide-arrow.png" /></div>
            <div class="desc">
                点击右上角
                <img class="shape" src="static/image/guide-shape.png" />
                分享
            </div>
            <div class="diyClose" @click="modalCancel">我知道了</div>
        </div>
    </van-dialog>
</template>


<script>
import { Dialog } from 'vant';
export default {
    components: {
        [Dialog.Component.name]: Dialog.Component,
    },
    props: {
        isWechat: {
            type: Boolean,
            default: false
        }
    },
    data(){
        return{
            isVisibility: false,
        }
    },
    created() {

    },
    mounted() {

    },
    methods:{
        openModel(){
            this.isVisibility = true
        },
        modalOk(){
            this.isVisibility = false;
            // this.$emit('refreshRecord');
        },
        modalCancel(){
              this.isVisibility = false;
            //   this.$emit('refreshRecord');
        },
        nextStep(){
            this.$emit('nextStep');
        }
    },
}
</script>

<style lang="scss" scoped>
    .van-dialog{
        width: 100%;
        overflow: initial;
        background-color: transparent;
        top: 0;
        left: 0;
        transform: none;
        /deep/ .van-dialog__content {
            margin: 0;
            padding: 0;
            width: 100%;
            height: 100vh;
            .diyModal {
                margin-left: 19px;
                width: 100vw;
                height: 100vh;
                &.wechat{
                    margin-left: 65px;
                }
                .arrow-wrap{
                    position: relative;
                    width: 98px;
                    height: 98px;
                    margin-bottom: 5px;
                    width: 100vw;
                    .arrow{
                        width: 98px;
                        height: 98px;
                        position: absolute;
                        right: 75px;
                        top: 0;
                    }
                }
                .desc{
                    font-family: HYQiHei-GZS;
                    font-size: 16px;
                    color: #FFFFFF;
                    text-align: center;
                    font-weight: 400;
                    margin-bottom: 15px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    .shape{
                        width: 18px;
                        height: 6px;
                        margin: 0 5px;
                    }
                }
                .diyClose {
                    border: 1px solid #FFFFFF;
                    width: 125px;
                    height: 36px;
                    color: #FFFFFF;
                    font-weight: 400;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin: 0 auto;
                    border-radius: 36px;
                    font-family: HYQiHei-FZS;
                    font-size: 14px;
                }
            }
        }
    }
</style>




// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/dynamicAttr/modal/guideModal.vue